// @flow
export const places = { // eslint-disable-line import/prefer-default-export
  'f5992ca8-9888-4152-ae80-32cc6a429eae': {
    placeId: 'f5992ca8-9888-4152-ae80-32cc6a429eae',
    description: 'Баннер в главном меню',
    width: 1100,
    height: 180,
  },
  'd099e4c6-f44b-42ef-b5f9-a1d52c27dee5': {
    placeId: 'd099e4c6-f44b-42ef-b5f9-a1d52c27dee5',
    description: 'Баннер в приложениях',
    width: 364,
    height: 444,
  },
};
